export default {
      id: "depth-5-usage",
      viewBox: "0 0 127 15",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#depth-5",
      toString: function () {
        return this.url;
      }
    }